import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function LatestArticles() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新内容
            </h2>
            <p className="text-foreground-600">持续更新，精彩不间断</p>
          </div>
          <Link
            to="/category/zuixin-zixun"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            更多内容 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-24 h-24 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={article.thumbUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full">
                    {article.tags[0]}
                  </span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 mb-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span>{article.readTime} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <Link
          to="/category/zuixin-zixun"
          className="sm:hidden mt-6 flex items-center justify-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200"
        >
          更多内容 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}